module.exports = "/images/vendor/tui-image-editor/dist/svg/icon-d.svg?4ef3abbd14fbe85ceebf36d900d2c9ad";